import { api } from '../api';

const ANALYTICS_URL = 'analytics';

const customerAnalyticsJSONApi = {
  fetch: (options) => api.fetchJSON(`${ANALYTICS_URL}/customer`, options),
};

export const getCustomerAnalytics = () =>
  customerAnalyticsJSONApi
    .fetch({
      method: 'GET',
    })
    .then((data) => data);
